<template>
  <div class="accounts-wrap">
    <ListFilter
      :formList="filterFormList"
      @search="searchHandle"
      wstyle="background-color: transparent;padding: 0;"
      @newadd="toggleEditor(true)"
      :newadd="true"
      :newaddConfig="{ type: 'primary', plain: true }"
    />
    <div class="accounts-list">
      <div class="accounts-list-toolbar">
        <span>按分组展示</span>
        <el-switch v-model="groupDisplay" />
      </div>
      <el-table :data="list" style="width: 100%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
        <template #empty><Empty style="margin-top: 56px;" /></template>
        <el-table-column fixed prop="carrierCode" label="船公司" width="128" />
        <el-table-column prop="accounts" label="账号">
          <template #default="scope">
            <div class="accounts-list-detail">
              <div class="account-group" v-for="group in displayAccountGroups(scope.row.accounts)" :key="group.key">
                <div class="account-group-title" v-if="groupDisplay" @click="toggleGroup(scope.row.carrierId, group.key)">
                  <el-icon class="account-group-fold"><ArrowRight v-if="isGroupCollapsed(scope.row.carrierId, group.key)" /><ArrowDown v-else /></el-icon>
                  <span class="account-group-dot" />
                  <span>{{ group.name }}</span>
                  <span class="account-group-divider" />
                  <em>{{ group.accounts.length }} 项</em>
                </div>
                <div class="account-group-items" v-show="!groupDisplay || !isGroupCollapsed(scope.row.carrierId, group.key)">
                  <div class="item" v-for="item in group.accounts" :key="item.id">
                    <label>{{item?.useModeName}}</label>
                    <span>{{item?.account}}</span>
                    <div class="account-item-ctrl" style="margin-left: 13px;" @click="toggleEditor(true, {...scope.row, account: item})">
                      <el-icon :size="14" color="#4EBE41"><Edit /></el-icon>
                    </div>
                    <el-popconfirm :hide-after="0" :teleported="true" title="你确定要删除吗?" width="208px">
                      <template #reference>
                        <div class="account-item-ctrl">
                          <el-icon :size="14" color="#FF4D4F"><Delete /></el-icon>
                        </div>
                      </template>
                      <template #actions="{ confirm, cancel }">
                        <el-button size="small" @click="cancel">取消</el-button>
                        <el-button type="primary" size="small" @click="deleteAccountHandle(item, confirm)">确定</el-button>
                      </template>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updatedTime" label="最近更新时间" width="208">
          <template #default="scope">
            <span>{{ scope.row?.updatedTime && moment(scope.row.updatedTime).format('YYYY MM.DD HH:mm') || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="操作" fixed="right" align="right" width="108">
          <template #default="scope">
            <el-popconfirm title="你确定要删除吗?" width="208px">
              <template #reference>
                <el-button link type="danger">删除</el-button>
              </template>
              <template #actions="{ confirm, cancel }">
                <el-button @click="cancel" size="small">取消</el-button>
                <el-button type="primary" size="small" @click="deleteHandle(scope.row, confirm)">确定</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <Spagination
        :page="page"
        :size="size"
        :total="total"
        @current-change="val => page = val"
      />
    </div>
  </div>

  <Modal :title="form.id ? '编辑账号' : '新建账号'" @cancel="toggleEditor(false)" @submit="submitNewAddHandle" v-if="showNewAdd">
    <el-form :model="form" label-position="top">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="船公司" required>
            <el-select v-model="form.carrierId" placeholder="请选择" clearable @change="carrierChangeHandle">
              <el-option v-for="(itm, idx) in carrierList" :label="itm.carrierCode" :value="itm.id" :key="idx" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用范围" required>
            <el-select v-model="form.useMode" placeholder="请选择" clearable>
              <el-option v-for="(itm, idx) in Object.keys(CONST.USE_MODE_LABEL).map(v => ({ value: Number(v), label: CONST.USE_MODE_LABEL[v] }))" :label="itm.label" :value="itm.value" :key="idx" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="账号" required>
            <el-input v-model.trim="form.account" placeholder="请输入" :disabled="form.id" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" required>
            <el-input v-model.trim="form.password" placeholder="请输入" type="password" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="账号分组">
            <el-select v-model="form.groupId" placeholder="请选择" clearable>
              <el-option v-for="item in groupList" :label="item.groupName" :value="item.id" :key="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </Modal>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import moment from 'moment';
  import { ArrowDown, ArrowRight, Delete, Edit } from '@element-plus/icons-vue'
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import Empty from '@/components/empty';
  import Modal from '@/components/modal';
  import * as Request from '@/assets/request'
  import * as CONST from '@/assets/const'
  import { ElMessage } from 'element-plus';

  /**
   * 筛选
   */
  const filterFormList = ref([])
  const filterFormListInit = () => {
    filterFormList.value = [
    {
        type: 'select', field: 'carrierId',
        label: '船公司', placeholder: '请选择',
        options: []
      },
      {
        type: 'select', field: 'useMode',
        label: '账号类型', placeholder: '请选择',
        options: Object.keys(CONST.USE_MODE_LABEL).map(value => ({ value: Number(value), label: CONST.USE_MODE_LABEL[value] }))
      },
    ]
  }
  onMounted(() => {
    filterFormListInit()
  })
  // 获取所有app
  const carrierList = ref([])
  const getAllCarrier = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/getAllCarrier'
    });
    if(result?.code != 200) return;

    let _options = [];
    if(result?.data?.length > 0) {
      result.data.map(item => {
        _options.push({ value: item?.id, label: item?.carrierCode })
      })
    }
    filterFormList.value.map(item => {
      if(item?.field == 'carrierId') {
        item.options = _options
      }
      return item;
    })
    carrierList.value = result?.data

    console.log('filterFormList', filterFormList.value)
  }
  onMounted(() => {
    getAllCarrier()
  });

  const groupList = ref([])
  const getGroupsByCarrierId = async carrierId => {
    if(!carrierList.value.length) {
      await getAllCarrier();
    }
    const carrier = carrierList.value.find(item => item.id === carrierId);
    if(!carrier?.carrierCode) {
      groupList.value = [];
      return;
    }
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/group/getByCarrierCode',
      data: carrier.carrierCode
    });
    if(result?.code !== 200) return;

    groupList.value = result?.data || [];
  }
  const carrierChangeHandle = carrierId => {
    form.value.groupId = undefined;
    getGroupsByCarrierId(carrierId);
  }
  // 搜索
  const searchHandle = data => {
    listQuery.value = {...data};
    page.value = 1;
  }

  /**
   * 列表
   */
  const list = ref([])
  const groupDisplay = ref(false)
  const collapsedGroups = ref({})
  const listQuery = ref({})
  const total = ref(0)
  const size = ref(50)
  const page = ref(1)
  const getList = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/searchList',
      data: {
        ...listQuery.value,
        page: page.value,
        size: size.value
      }
    })
    if(result?.code != 200) return;

    list.value = result.data.content;
    total.value = result.data.total;
  }
  onMounted(() => {
    getList()
  })
  onMounted(() => {
    getList()
  })
  watch(() => [ listQuery.value, page.value ], () => {
    getList();
  }, { deep: true })

  const displayAccountGroups = accounts => {
    if(!groupDisplay.value) {
      return [{ key: 'all', accounts: accounts || [] }];
    }
    const groupMap = new Map();
    (accounts || []).forEach(account => {
      const grouped = Boolean(account?.groupId);
      const key = grouped ? `group-${account.groupId}` : 'ungrouped';
      if(!groupMap.has(key)) {
        groupMap.set(key, {
          key,
          name: grouped ? account.groupName || '未命名分组' : '未分类',
          sort: grouped ? account.groupSort ?? Number.MAX_SAFE_INTEGER : Number.MAX_SAFE_INTEGER,
          accounts: []
        });
      }
      groupMap.get(key).accounts.push(account);
    });
    return Array.from(groupMap.values()).sort((a, b) => a.sort - b.sort || a.name.localeCompare(b.name));
  }

  const groupCollapseKey = (carrierId, groupKey) => `${carrierId}-${groupKey}`
  const isGroupCollapsed = (carrierId, groupKey) => Boolean(collapsedGroups.value[groupCollapseKey(carrierId, groupKey)])
  const toggleGroup = (carrierId, groupKey) => {
    const key = groupCollapseKey(carrierId, groupKey)
    collapsedGroups.value[key] = !collapsedGroups.value[key]
  }

  /**
   * 操作
   */
  // 删除
  const deleteHandle = async (item, callback) => {
    console.log('item--', item)
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/deleteByCarrierId',
      data: item?.carrierId
    })
    if(result?.code != 200) return;

    getList()
    if(typeof callback == 'function') {
      callback()
    }
  }

  const showNewAdd = ref(false);
  const form = ref({});
  const toggleEditor = (flag, data) => {
    showNewAdd.value = flag;
    if(!flag) {
      form.value = {}
    }else{
      if(data) {
        const accountInfo = data?.account || data?.accounts[data?.accountIndex];
        form.value = {
          id: accountInfo?.id,
          carrierId: data.carrierId,
          useMode: accountInfo?.useMode,
          groupId: accountInfo?.groupId,
          account: accountInfo?.account
        }
        getGroupsByCarrierId(data.carrierId);
      }
    }
  }
  const submitNewAddHandle = async () => {
    const submitObj = form.value;
    let url = '/22001/facade/commons/carrier/account/add';
    if(submitObj.id) {
      url = '/22001/facade/commons/carrier/account/update';
    }
    const result = await Request.post({
      url,
      data: submitObj
    })
    if(result?.code != 200) return;
    ElMessage.success(submitObj.id ? '编辑成功' : '新建成功');
    toggleEditor(false);
    getList()
  }

  // 删除账号
  const deleteAccountHandle = async (item, confirm) => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/deleteById',
      data: item?.id
    })
    if(result?.code != 200) return;
    ElMessage.success('已删除');

    confirm()
    setTimeout(() => {
      getList()
    }, 555);
  }
</script>

<style scoped lang="less">
  @import "./index.less";
</style>
